import type { Event } from '@/types';

export type TicketMode = 'mealChoice' | 'multiTenant';

export function getEventTicketMode(event: Pick<Event, 'ticketMode'> | null | undefined): TicketMode {
  return event?.ticketMode === 'multiTenant' ? 'multiTenant' : 'mealChoice';
}

export function isMultiTenantEvent(event: Pick<Event, 'ticketMode'> | null | undefined): boolean {
  return getEventTicketMode(event) === 'multiTenant';
}

export const TICKET_MODE_DESCRIPTIONS: Record<TicketMode, { label: string; description: string }> = {
  mealChoice: {
    label: 'Meal Choice Tickets',
    description: 'Guests choose one ticket type, then select their meal/course options.',
  },
  multiTenant: {
    label: 'Multi Tenant Ticketing',
    description:
      'Guests choose a quantity of each ticket type in a single purchase (e.g. "5x Standard"), with no per-guest meal choices or individual check-in — ideal for one person booking for a group.',
  },
};
